import mBrandCard1 from "./BrandCard1.vue";
import mBrandCard2 from "./BrandCard2.vue";
import mBrandCard3 from "./BrandCard3.vue";

export const Cards = {
    mBrandCard1,
    mBrandCard2,
    mBrandCard3,
}